import "./index.scss"
function Partner() {
  const list = [
    {
      id: 1,
      title: "政策性银行",
      img: require("../../../../assets/partner1.png")
    },
    {
      id: 2,
      title: "央企",
      img: require("../../../../assets/partner2.png")
    },
    {
      id: 3,
      title: "央企金融租赁",
      img: require("../../../../assets/partner3.png")
    },
    {
      id: 4,
      title: "股份制银行",
      img: require("../../../../assets/partner4.png")
    },
    {
      id: 5,
      title: "信托",
      img: require("../../../../assets/partner5.png")
    },
    {
      id: 6,
      title: "国有AMC",
      img: require("../../../../assets/partner6.png")
    },
    {
      id: 7,
      title: "金融行业专业服务商",
      img: require("../../../../assets/partner7.png")
    },

  ]
  return (
    <div className="partner-container">
      <div className="subtitle">合作伙伴</div>
      <div className="title">COOPERATIVE PARTNER</div>
      <div className="partner-info">
        {list.map((item, index) => {
          return (
            <div key={index} className="list-item">
              <div className="img-box">
                <img className="img" src={item.img}></img>
              </div>
              <div className="title-row">
                {item.title}
              </div>


            </div>
          )
        })}


      </div>

    </div>
  )
}
export default Partner